import React from "react";
import _ from "underscore";
import closeIcon from "../../assets/svgs/icon-close.svg";
import removeIcon from "../../assets/svgs/icon-remove.svg";
import ellipseIcon from "../../assets/svgs/ellipse.svg";

// Opens entire page covering modal. Used for confirmations.
export const ImagePreviewModal = ({
  imgFile,
  imgHelptext,
  onConfirm,
  onCancel,
  onClose,
  visible,
}) => {
  const { preview: imgSrc, isExistingImage } = imgFile;
  return (
    <div
      className="confirmation-modal"
      style={{ display: visible ? "flex" : "none" }}
      onClick={onClose}
    >
      <div className="img-modal-content">
        <div className="img-modal-header">
          <img
            onClick={onConfirm}
            className="remove-image"
            src={removeIcon}
            alt="remove-icon"
          />
          <img
            onClick={onCancel}
            className="close-image"
            src={closeIcon}
            alt="close-icon"
          />
        </div>
        <img src={imgSrc} alt="Preview" className="image-preview-modal" />
        {isExistingImage && (
          <div className="img-modal-footer">
            <img
              className="ellipse-icon-text"
              src={ellipseIcon}
              alt="ellipse-icon"
            />
            <span className="footer-text">{ imgHelptext }</span>
          </div>
        )}
      </div>
    </div>
  );
};
